import {
  gatewayGet,
  gatewayPost,
} from './fetch';

// adds 'gateway' proxy to platform endpoints
export const platformPost = async (endpoint = '', payload = {}, headers = {}) => gatewayPost(`/platform${endpoint}`, {
  ...payload,
}, headers);

export const platformGet = async (endpoint = '', query = {}, options = {}) => {
  const { abortController, headers, loggerLevel, ms } = options;
  return gatewayGet(`/platform${endpoint}`, query, ms, abortController, headers, loggerLevel);
};
